// extracted by mini-css-extract-plugin
export var numpadContainer = "_sd-1";
export var phoneButton = "_sd-0";